import "./CustomerTotals.scss";
import {
  PdfIcon,
  LockIcon,
  PlusIcon,
  CartIcon,
  ArrowDownIcon,
} from "../../../../shared/margincalculator/components/icons/Icon";

function CustomerTotals() {
  const formatPrice = (price: number) =>
    price.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div className="customer-totals">
      {/* 1. Customer Totals Card */}
      <div className="customer-totals__card">
        <div className="customer-totals__header">
          <h3>Customer Totals</h3>
        </div>

        <div className="customer-totals__row">
          <span className="label">Avg. Monthly</span>
          <span className="value">{formatPrice(29.0)} €</span>
        </div>

        <div className="customer-totals__row">
          <span className="label">One-Time Costs</span>
          <span className="value">{formatPrice(0.0)} €</span>
        </div>

        <div className="customer-totals__divider" />

        <div className="customer-totals__row">
          <span className="label">24-Month Total</span>
          <span className="value value--total">{formatPrice(696.0)} €</span>
        </div>

        <p className="customer-totals__info-text">
          *includes all discounts and taxes
        </p>
      </div>

      {/* 2. Dealer Margins Card */}
      <div className="customer-totals__card">
        <div className="customer-totals__header">
          <h3>
            <LockIcon /> Dealer Margins
          </h3>
          <span className="customer-totals__badge customer-totals__badge--internal">
            Internal Only
          </span>
        </div>

        <div className="customer-totals__row">
          <span className="label">Total Margin</span>
          <span className="value value--margin">{formatPrice(250.0)} €</span>
        </div>

        <div className="customer-totals__row">
          <span className="label">Total Provision</span>
          <span className="value value--margin">{formatPrice(250.0)} €</span>
        </div>
      </div>

      {/* 3. Actions */}
      <div className="customer-totals__actions">
        <button className="customer-totals__btn customer-totals__btn--pdf">
          <PdfIcon /> PDF
        </button>
        <button className="customer-totals__btn customer-totals__btn--pdf-outline">
          <LockIcon /> Händler-PDF
        </button>
        <a href="#" className="customer-totals__small-help">
          Need help calculating margins?
        </a>

        <button className="customer-totals__btn customer-totals__btn--offer">
          <PlusIcon /> Zum Angebot
        </button>
      </div>

      {/* 4. Basket */}
      <div className="customer-totals__basket">
        <div className="customer-totals__basket-header">
          <div className="left">
            <CartIcon /> Basket
          </div>
          <ArrowDownIcon />
        </div>
        <div className="customer-totals__basket-body">
          <p className="empty-text">0 Tarife gesammelt</p>
          <button className="customer-totals__btn customer-totals__btn--secondary">
            <PlusIcon /> Angebot erstellen
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomerTotals;
